(function () {
    'use strict';

    angular
        .module('homeDashboardControllers', [
            'services.permission',
            'actionPlanModule',
            'businessPlanningModule',
            'governanceProcessModule',
            'aricModule',
            'recommendationModule',
            'riskModule',
            'recomModule'
        ]);
})();
